import { connect } from 'react-redux';
import {
  fetchWork
} from 'arts/actions/work';
import WorkFilter from './work_filter';

const mapStateToProps = ({ work: { data } }) => data || {};

export default connect(mapStateToProps, { fetchWork })(WorkFilter);
